import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTelephone: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconTelephone"><Path d="M3.75 3C3.33579 3 3 3.33579 3 3.75V5.8125C3 14.2003 9.79968 21 18.1875 21H20.25C20.6642 21 21 20.6642 21 20.25V15.0938C21 14.8097 20.8395 14.55 20.5854 14.4229L16.4604 12.3604C16.1717 12.2161 15.8229 12.2726 15.5947 12.5009L14.4051 13.6905C12.4366 12.8075 11.1925 11.5634 10.3095 9.59491L11.4991 8.40533C11.7274 8.17706 11.7839 7.82833 11.6396 7.53959L9.57707 3.41459C9.45003 3.1605 9.19033 3 8.90625 3H3.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTelephone;
